/**
 * Vue 3 click-outside directive.
 *
 * Replaces the `v-click-outside` npm package, which only implements the Vue 2
 * hook names (`bind` / `unbind`). Vue 3 silently ignores those, so the picker
 * never closed on an outside click after the migration.
 */
const HANDLER = Symbol('clickOutsideHandler');
const CALLBACK = Symbol('clickOutsideCallback');

export default {
  beforeMount(el, binding) {
    el[CALLBACK] = binding.value;
    el[HANDLER] = (event) => {
      if (el === event.target || el.contains(event.target)) return;
      if (typeof el[CALLBACK] === 'function') el[CALLBACK](event);
    };
    // Capture phase so handlers that stop propagation cannot hide the click.
    document.addEventListener('click', el[HANDLER], true);
  },
  updated(el, binding) {
    el[CALLBACK] = binding.value;
  },
  unmounted(el) {
    document.removeEventListener('click', el[HANDLER], true);
    delete el[HANDLER];
    delete el[CALLBACK];
  },
};
